import { Component, Vue } from 'vue-property-decorator'
import { queryClassListPaper, paperCurrentInfo, editGroup, setClassLunwenTeacher, queryPaperGroupStudent, makePaperGroup, getTeacherLunwen, getReplaceTeacher, giveUpFreePaperClass, queryPaperChargeCommon, setPaperCharge } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
import axios from 'axios'
import urlBase from '@/utils/urlBase'

axios.defaults.withCredentials = true
@Component({ name: 'paper-list-page', components: { HighFilter } })
export default class PaperListPage extends Vue {
  private useRole: any = []
  private dataType = 1
  private tableData = []
  private totalPage = 1;
  private currentPage = 1;
  private filterResult: any = null
  private filterData: any = null
  private showHighFilter: any = false
  private chaiDialogVisible = false
  private administrationchaiDialog = false
  private tuijianDialogVisible = false
  private chooseDialogVisible = false
  private replaceDialogVisible = false // 替换导师弹窗
  private makeGroupDialogVisible = false; // 论文结组
  private time: any = null;
  private chooseData: any = null
  private chooseDataClassId: any = null

  private teacherList: any = []
  private mainTeacherChoose = ''
  private mainTeacherList: any = []
  private bufferTeacher1Choose = ''
  private bufferTeacher2Choose = ''
  private tableloading: any = false

  // 选择论文导师
  private teacherLunwenChoose: any = ''
  private teacherCanChooseList: any = []
  private recommendType: any = null

  // 替换导师
  private replaceTeacher: any = null
  private teacherData: any = null
  private replaceBeforTeacher: any = null
  private replaceTeacherList: any = []
  private checkBeforTeacher: any = null
  // 论文负责人
  private personInCharge: any =false
  private personInChargeObj: any = null
  private personInChargeList: any = null
  private personInChargeObjid: any = null
  private personInChargeClassIdList: any = null
  // 论文结组
  private groupNameInput: any = ''
  private groupStudent: any = []
  private administrationgroupStudentgroupStudent: any = []
  private chooseGroupStudents: any = []
  private administrationchooseGroupStudents: any = {}
  private administrationgroupStudent: any = []
  private val: any = '忽闪忽闪山山水水'
  created () {
    this.useRole = this.$store.state.user.roles
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('质检专员') > -1 || item.indexOf('质检总监') > -1)) {
      this.dataType = 2
    }
    this.initPageData()
  }

  private getRowKeys (row: any) {
    return row.classId
  }

  private async initPageData () {
    // const list: any = [{ path: '/class/paper/create/group', name: 'makePaperGroup' }, { name: 'giveUpFreePaperClass', path: '/class/freePaperClass/giveUp' },
    //   { path: '/class/paper/edit/group', name: 'editGroup' }, { name: 'setClassLunwenTeacher', path: '/class/paper/chooseMaster' }, { name: 'setPaperCharge', path: '/class/paper/setPaperCharge' }
    // ]
    this.tableloading = true
    const param: any = { isGroup: this.dataType * 1 === 2, page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryClassListPaper(param)
    this.currentPage = result.currentPage
    this.totalPage = result.allPage
    this.tableData = result.classList
    this.filterData = result.search
    this.tableloading = false
  }

  private async downloadTemplate () {
    this.tableloading = true
    const param: any = { isGroup: this.dataType * 1 === 2, exportExcel: true }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    // const url = 'http://192.168.0.33:10069/class/query/summary/for/paperGroup'
    const url = urlBase.eduBaseUrl + 'class/query/summary/for/paperGroup'
    axios.defaults.headers = {
      'Content-Type': 'application/json' // 这儿是通过json格式 传值，如果需要通过formData形式，可以改，详情 https://www.cnblogs.com/honkerzh/p/14157038.html
    }
    axios({ // 用axios发送post请求
      method: 'post',
      url: url, // 请求地址
      data: param, // 参数
      responseType: 'blob' // 表明返回服务器返回的数据类型
    })
      .then((res: any) => { // 处理返回的文件流
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        }) // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        const url = window.URL.createObjectURL(blob) // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        const a = document.createElement('a')
        a.href = url
        a.download = '论文组表格.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      })
    this.tableloading = false
  }

  private async onTypeChange (type: any) {
    if (!this.tableloading) {
      this.currentPage = 1
      this.filterResult = null
      this.dataType = type
      this.initPageData()
    }
  }

  private async onPageChange () {
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  private async onChaiClicked (data: any) {
    this.chooseDataClassId = data.classId
    const result = await queryPaperGroupStudent({ classId: data.classId })
    this.administrationgroupStudent = result
    const result1: any = await paperCurrentInfo({ classId: data.classId })
    this.chooseData = result1
    this.administrationchaiDialog = true
  }

  // 未结组查看学员详情
  private async uncommittedRowClicked (row: any) {
    this.$router.push({ path: '/student/detail', query: { id: row.students[0].id, detailType: '2' } })
  }

  // 已结组论文详情
  private async allcommittedRowClicked (row: any) {
    if (Number(row.templateType) === 3) {
      this.$router.push({ path: '/student/lunwenDetail1', query: { classId: row.classId } })
    } else {
      this.$router.push({ path: '/student/lunwenDetail', query: { classId: row.classId } })
    }
  }

  private async giveUpPaper (row: any) {
    this.$confirm('确认放弃论文服务', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(async () => {
      const { error }: any = await giveUpFreePaperClass({ classId: row.classId, isGiveUp: true, sellOrderId: row.students[0].sellOrderId })
      if (!error) {
        this.$message({ type: 'success', message: '放弃服务成功' })
        this.initPageData()
      }
    })
  }

  private async recoveryPaper (row: any) {
    this.$confirm('确认恢复论文服务', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(async () => {
      const { error }: any = await giveUpFreePaperClass({ classId: row.classId, isGiveUp: false, sellOrderId: row.students[0].sellOrderId })
      if (!error) {
        this.$message({ type: 'success', message: '恢复服务成功' })
        this.initPageData()
      }
    })
  }

  // 结组查看学员详情
  private async committedRowClicked (row: any) {
    this.$router.push({ path: '/student/detail', query: { id: row.id, detailType: '2' } })
  }

  private handleSelectionChange (val: any) {
    this.personInChargeClassIdList = val.map((x: any) => x.classId)
  }

  private async setpersonInCharge (row: any) {
    if (!this.personInChargeList) {
      const result: any = await queryPaperChargeCommon({})
      this.personInChargeList = result
    }
    if (row) {
      this.personInChargeObj = row
    }
    this.personInCharge = true
  }

  private async onsetpersonInCharge () {
    let classIdList: any = null
    if (this.personInChargeObj && this.personInChargeObj.classId) {
      classIdList = [this.personInChargeObj.classId]
    } else {
      classIdList = this.personInChargeClassIdList
    }
    const { error }: any = await setPaperCharge({ classId: classIdList, chargeId: this.personInChargeObjid })
    if (!error) {
      this.$message({ type: 'success', message: '操作成功' })
      this.cancelonsetpersonInCharge()
      this.initPageData()
    }
  }

  cancelonsetpersonInCharge () {
    this.personInCharge = false
    if (this.personInChargeObj && this.personInChargeObj.classId) {
      this.personInChargeObj = null
    } else {
      this.personInChargeClassIdList = null
      const multipleTable: any = this.$refs.multipleTable
      multipleTable.clearSelection()
    }
    this.personInChargeObjid = null
  }

  // 小组管理确定按钮 如果清空选择的成员提示拆组弹框
  private async administrationSureClicked () {
    if (this.chooseData.studentList.length < 1) {
      this.chaiDialogVisible = true
    } else {
      const newlist = this.chooseData.studentList.map(function (item: any) {
        return { sellOrderId: item.sellOrderId }
      })
      const { error }: any = await editGroup({ classId: this.chooseDataClassId, className: this.chooseData.className, studentList: newlist })
      if (!error) {
        this.$message({ type: 'success', message: '修改成功' })
        this.chooseData = null
        this.administrationchooseGroupStudents = []
        this.administrationchaiDialog = false
        this.initPageData()
      }
    }
  }

  // 小组管理新增学员下拉框 去重
  private administrationStudents () {
    this.administrationchooseGroupStudents.forEach((item: any) => {
      const obj = this.administrationgroupStudent.find((item1: any) => item1.sellOrderId === item)
      if (this.chooseData.studentList.length > 0 && this.chooseData.studentList.every((item1: any) => item1.sellOrderId !== item)) {
        this.chooseData.studentList.unshift(obj)
      } else if (this.chooseData.studentList.length < 1) {
        this.chooseData.studentList.unshift(obj)
      }
    })
  }

  // 小组管理删除学员
  private detelechoosestudentList (tag: any) {
    if (this.administrationchooseGroupStudents.find((item: any) => item === tag.sellOrderId)) {
      this.administrationchooseGroupStudents.splice(this.administrationchooseGroupStudents.indexOf(tag), 1)
    }
    this.chooseData.studentList.splice(this.chooseData.studentList.indexOf(tag), 1)
  }

  // 清空学员拆组
  private async onChaiSureClicked () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      const { error }: any = await editGroup({ classId: this.chooseDataClassId, className: this.chooseData.className, studentList: [] })
      if (!error) {
        this.chaiDialogVisible = false
        this.administrationchaiDialog = false
        this.$message({ type: 'success', message: '拆组成功' })
        this.chooseData = null
        this.initPageData()
      }
    }, 200)
  }

  // 推荐论文老师
  private async onTuijianSureClicked () {
    // const alterMasterId = []
    // if (this.bufferTeacher1Choose) alterMasterId.push(this.bufferTeacher1Choose)
    // if (this.bufferTeacher2Choose) alterMasterId.push(this.bufferTeacher2Choose)
    if (this.recommendType) {
      this.$confirm('替换后，原信息将全部清除，课程需要重新排', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        const { error }: any = await setClassLunwenTeacher({ classId: this.chooseData.classId, masterId: this.mainTeacherChoose })
        if (!error) {
          this.$message({ type: 'success', message: '替换成功' })
          this.initPageData()
          this.tuijianDialogVisible = false
        }
      })
    } else {
      const { error }: any = await setClassLunwenTeacher({ classId: this.chooseData.classId, masterId: this.mainTeacherChoose })
      if (!error) {
        this.$message({ type: 'success', message: '匹配成功' })
        this.initPageData()
        this.tuijianDialogVisible = false
      }
    }
  }

  // 推荐导师
  private async onTuiJianClicked (data: any, recommendType: any) {
    this.recommendType = recommendType
    // -- 数据初始化 --
    this.mainTeacherChoose = ''
    this.bufferTeacher1Choose = ''
    this.bufferTeacher2Choose = ''
    this.chooseData = data
    const result1 = await getTeacherLunwen({ })
    this.mainTeacherList = result1
    this.tuijianDialogVisible = true
    if (this.chooseData.paperMasterItemList.length) {
      const obj = this.chooseData.paperMasterItemList.find((item: any) => item.type === '1' || item.type === 1)
      this.mainTeacherChoose = obj.userId
    }
  }

  // 选择导师弃用
  private async onChooseTeacherSureClicked () {
    await setClassLunwenTeacher({ classId: this.chooseData.classId, masterId: this.teacherLunwenChoose })
    this.$message({ type: 'success', message: '操作成功' })
    this.initPageData()
    this.chooseDialogVisible = false
  }

  // 结组学生详情接口
  private async onMakeGroupClicked (data: any) {
    console.log('data: ', data)
    this.chooseGroupStudents = []
    this.chooseData = data
    this.groupNameInput = ''
    const result: any = await queryPaperGroupStudent({ classId: data.classId })
    if (result && result.error && result.error.returnCode !== 0) {
      return
    }
    this.groupStudent = result
    this.makeGroupDialogVisible = true
    // 禁用选中学生 并放在第一位
    const list = this.groupStudent.map((item: any) => item.sellOrderId)
    const index = this.groupStudent.findIndex((item: any) => item.sellOrderId === data.students[0].sellOrderId)
    const item = list.splice(index, 1)[0]
    list.unshift(item)
    this.chooseGroupStudents = list
  }

  private async onMakeGroupSureClicked () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      const { error }: any = await makePaperGroup({ className: this.groupNameInput, type: this.chooseData.classType, courseId: this.chooseData.courseId, sellOrderIds: this.chooseGroupStudents })
      if (!error) {
        this.makeGroupDialogVisible = false
        this.$message({ type: 'success', message: '结组成功' })
        this.initPageData()
        this.chooseGroupStudents = []
      }
    }, 300)
  }

  // 班主任操作：弃用
  // /teacher/paperMaster/query/summay/by/class
  // 选择导师：班主任从 教研人员已经推荐了的三个导师 选一个
  // 替换导师：刚才剩余的两个中选一个，已经选择的导师不能被教研的人改
  // 教研操作：
  // 推荐导师：教研人员从论文导师库中选择三个，更改也是这个按钮 teacher/paperMaster/query/summary/common 弃用
  private async onReplaceClicked (data: any, type: any) {
    const result: any = await getReplaceTeacher({ classId: data.classId })
    this.teacherData = result
    this.chooseData = data
    if (result.alterMaster || result.mainMaster) {
      const list: any = [...result.alterMaster, ...[result.mainMaster]]
      const obj = list.find((item: any) => item.isCurrent)
      const current: any = result.mainMaster
      const checklist: any = result.alterMaster
      if (type === 1) { // 替换导师
        this.replaceBeforTeacher = current
        this.replaceTeacherList = checklist
        this.replaceTeacher = obj && obj.id !== current.id ? obj.id : ''
      } else { // 选择论文导师
        this.checkBeforTeacher = current
        this.teacherList = checklist
        this.teacherLunwenChoose = obj ? obj.id : ''
      }
    }
    type === 1 ? this.replaceDialogVisible = true : this.chooseDialogVisible = true
  }

  private async resetData () {
    this.mainTeacherChoose = ''
    this.bufferTeacher1Choose = ''
    this.bufferTeacher2Choose = ''
    this.teacherLunwenChoose = ''
    this.replaceTeacher = ''
    this.replaceBeforTeacher = {}
    this.replaceTeacherList = []
    this.checkBeforTeacher = {}
    this.teacherList = []
  }

  private async onReplaceTeacherSureClicked () {
    this.$confirm('替换后，原信息将全部清除，课程需要重新排', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(async () => {
      await setClassLunwenTeacher({ classId: this.chooseData.classId, masterId: this.replaceTeacher })
      this.replaceDialogVisible = false
      this.$message({ type: 'success', message: '操作成功' })
      this.initPageData()
      this.resetData()
    })
  }

  private async copylink (row: any) {
    const text = row.paperMasterUrl
    const input: any = document.getElementById('input')
    input.value = text // 修改文本框的内容
    input.select() // 选中文本
    document.execCommand('copy')
    this.$message({ message: '复制成功', type: 'success' })
  }
}
